<template>
  <div
    class="parallax contaier-overlay mt-5"
    id="parralax"
    style="overflow: hidden;"
  >
    <div class="scroll-overlay"></div>
    <div class="container-fluid">
      <div class="row">
        <div
          class="col-md-7 wow fadeInLeft"
          style="z-index: 7; color: #fff; margin-top: 100px;"
        >
          <h3 class="text-center para-head">
            Vous n'êtes qu'à un clic de votre médecin
          </h3>
          <p class="lead text-center">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia
            esse expedita magnam dolor, distinctio quasi.
          </p>
        </div>
        <div class="col-md-5 wow fadeInRight" style="z-index: 7;">
          <img
            src="@/assets/image/phoneMoc2.png"
            class="img-fluid mt-4 d-none d-md-block"
            alt="phones"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {};
</script>


<style lang="scss">
/* start parallex scroll */

.contaier-overlay {
  position: relative;
}
.contaier-overlay .scroll-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 6;
  bottom: 0;
  right: 0;
}

.info {
  background: url("../assets/image/koko.png") no-repeat center center;
  height: 600px;
  margin-bottom: -110px;
}
.info .avatar {
  width: 100px;
  margin: auto;
}
.info p {
  text-align: center;
  position: relative;
  padding: 20px;
}
.item .media {
  margin-top: 80px;
}
.parallax {
  height: 510px;
  width: 100vw;
  /* padding-top: 20vh; */
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
}
#parralax {
  background-image: url("../assets/image/mm.jpg");
}
.para-head {
  padding: 30px;
  font-size: 44px;
  margin: 0 0 30px;
  font-weight: 550;
}
</style>